import { SeverityType } from '@chr/eds-react/Tag/Tag';
import { RiskLevel } from '../apis/dtos';

export interface RiskLevelModel {
  type: RiskLevel;
  label: string;
  color: string;
  style: Style;
  order?: number;
}

interface Style {
  borderStyle: string;
  borderColor: { light: string; dark: string };
  severity: SeverityType;
}

const riskLevels: Record<RiskLevel, RiskLevelModel> = Object.freeze({
  [RiskLevel.OnTime]: {
    type: RiskLevel.OnTime,
    label: 'On Time',
    color: '#008015',
    style: {
      borderStyle: 'onTimeBorder',
      severity: 'positive',
      borderColor: { light: '#005C05', dark: '#FFF' },
    },
    order: 2,
  },
  [RiskLevel.AtRisk]: {
    type: RiskLevel.AtRisk,
    label: 'At Risk',
    color: '#FDC20C',
    style: {
      borderStyle: 'atRiskBorder',
      severity: 'warning',
      borderColor: { light: '#7B3203', dark: '#FFF' },
    },
    order: 3,
  },
  [RiskLevel.Late]: {
    type: RiskLevel.Late,
    label: 'Late',
    color: '#CD0202',
    style: {
      borderStyle: 'lateBorder',
      severity: 'negative',
      borderColor: { light: '#8E0000', dark: '#FFF' },
    },
    order: 4,
  },
  [RiskLevel.Early]: {
    type: RiskLevel.Early,
    label: 'Early',
    color: '#8400FF',
    style: {
      borderStyle: 'earlyBorder',
      severity: 'urgent',
      borderColor: { light: '#440082', dark: '#FFF' },
    },
    order: 1,
  },
  [RiskLevel.Unassigned]: {
    type: RiskLevel.Unassigned,
    label: 'Unassigned',
    color: '#AAAEB0',
    style: {
      borderStyle: 'unassignedBorder',
      severity: 'neutral',
      borderColor: { light: '#36383A', dark: '#FFF' },
    },
  },
});

export const getRiskLevel = (type: RiskLevel) => riskLevels[type];

export const getRiskLevelBorderStyle = (type: RiskLevel) => getRiskLevel(type).style.borderStyle;
